import { gql, useQuery } from '@apollo/client';

function useFindFabric(variables) {
  const { data, error, loading } = useQuery(FIND_PRODUCT, {
    variables: {
      ...variables
    },
    skip: Object.values(variables).every(x => x === null || x === '')
  });

  return { loading, error, data };
}

export default useFindFabric;

const FIND_PRODUCT = gql`
  query findFabrics(
    $fabric_id: Int
    $size_id: Int
    $firmness_id: Int
    $leg_id: Int
    $caster_leg_id: Int
    $frame_id: Int!
    $orientation: Int
    $is_assembled: Int
    $wallpaper_type: String
    $user_email: String
  ) {
    findProduct(
      fabric_id: $fabric_id
      size_id: $size_id
      firmness_id: $firmness_id
      leg_id: $leg_id
      caster_leg_id: $caster_leg_id
      frame_id: $frame_id
      orientation: $orientation
      is_assembled: $is_assembled
      wallpaper_type: $wallpaper_type
      user_email: $user_email
    ) {
      sku
      slug
      pdp_fabrics {
        id
        is_available_on_pdp
        name
        description
        is_product_sold_out
        is_kid
        popular_ranking
        image
        collaborator {
          id
          name
        }
        colors {
          id
          name
          hex_code
        }
        pattern {
          id
          name
        }
        material {
          id
          name
          composition
          durability
        }
      }
    }
  }
`;
